import tinymce from 'tinymce/tinymce'

import 'tinymce/themes/silver'

// require.context('!file-loader?name=[path][name].[ext]&context=tinymce!tinymce/plugins', true, /index\.js/)
// require.context('tinymce/plugins', true, /plugin\.js/)

import 'tinymce/plugins/advlist'
import 'tinymce/plugins/anchor'
import 'tinymce/plugins/autolink'
import 'tinymce/plugins/autoresize'
import 'tinymce/plugins/charmap'
import 'tinymce/plugins/code'
import 'tinymce/plugins/contextmenu'
import 'tinymce/plugins/directionality'
import 'tinymce/plugins/emoticons'
import 'tinymce/plugins/fullpage'
import 'tinymce/plugins/fullscreen'
import 'tinymce/plugins/help'
import 'tinymce/plugins/hr'
import 'tinymce/plugins/image'
import 'tinymce/plugins/imagetools'
import 'tinymce/plugins/link'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/media'
import 'tinymce/plugins/noneditable'
import 'tinymce/plugins/pagebreak'
import 'tinymce/plugins/paste'
import 'tinymce/plugins/preview'
import 'tinymce/plugins/searchreplace'
import 'tinymce/plugins/spellchecker'
import 'tinymce/plugins/table'
import 'tinymce/plugins/wordcount' 

import 'tinymce/skins/ui/oxide/skin.css'
// import 'tinymce/skins/ui/oxide/content.min.css'

require("@rails/activestorage").start()

document.addEventListener("turbolinks:load", () => {
    tinymce.remove();
    tinymce.init({
        font_formats: 'Arial=arial,helvetica;Helvetica=helvetica;Lato=lato,tahoma,sans-serif;Tahoma=tahoma,arial,helvetica,sans-serif;Times New Roman=times new roman,sans-serif',
        fontsize_formats: '11px 12px 14px 16px 18px 24px 36px 48px',
        selector: '#editor textarea',
        plugins: [
            "advlist anchor autolink charmap fullscreen help image imagetools",
            " lists link media noneditable pagebreak preview",
            " searchreplace table spellchecker wordcount code"
          ],
        toolbar: [
            "undo redo | fontselect fontsizeselect formatselect | preview fullscreen",
            "bold italic underline strikethrough | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | link media image | pagebreak charmap removeformat code",
            ],
        skin: false,
        content_css: false,
        height: 500,
        document_base_url: "/",
        relative_urls: false,
        image_class_list: [
          {title: 'img-fluid', value: 'img-fluid'}
        ],
        images_upload_base_path: '/rails/active_storage/blobs/',
        images_upload_handler: function (blobInfo, success, failure) {
          var xhr, formData;
          let model = document.querySelector("#megashira").getAttribute('model')
          let model_id = document.querySelector("#megashira input")
      
          xhr = new XMLHttpRequest();
          xhr.withCredentials = false;
          xhr.open('PATCH', '/' + model + '/' + model_id.value + '/new_picture/');
      
          xhr.onload = function() {
            var json;
      
            if (xhr.status != 200) {
              failure('HTTP Error: ' + xhr.status);
              return;
            }
      
            json = JSON.parse(xhr.responseText);
      
            if (!json || typeof json.location != 'string') {
              failure('Invalid JSON: ' + xhr.responseText);
              return;
            }
      
            success(json.location);
          };

          const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
          const editorName = document.querySelector("#megashira").getAttribute("singular");
          console.log(editorName)
      
          formData = new FormData();
          formData.append('authenticity_token', csrfToken)
          formData.append(editorName + "[pictures][]", blobInfo.blob(), blobInfo.filename());
      
          xhr.send(formData);
        },
        content_css: ['https://fonts.googleapis.com/css?family=Open+Sans&display=swap'],
        setup : function(ed)
        {
            ed.on('init', function() 
            {
                this.getDoc().body.style.fontSize = '16';
                this.getDoc().body.style.fontFamily = 'Open Sans';
            });
        },        
    });    
})